import { analytics } from '#/store/services/Firebase'
import { ResolvedPage } from '#/store/services/Pages/PagesService'

type HitAnalyticsParams = {
  page: ResolvedPage
  farmSlug: string
}
export async function hitAnalytics({ farmSlug: fazenda, page }: HitAnalyticsParams) {
  if (analytics && fazenda) {
    try {
      /* Import inside try-catch to catch adblock crashing by not loading analytics */
      const { logEvent } = await import('firebase/analytics')
      logEvent(analytics, 'page_view', { fazenda, page_title: page.track })
    } catch (e: any) {
      console.error('ANALYITCS BLOCKED BY CLIENT -> ', e)
    }
  }
}

/**
 * @function setAnalyticsUserInfo - set authenticated user info on Analytics
 * */
export async function setAnalyticsUserInfo(user) {
  if (analytics) {
    try {
      /* Import inside try-catch to catch adblock crashing by not loading analytics */
      const { setAnalyticsCollectionEnabled, setUserId, setUserProperties } =
        await import('firebase/analytics')
      setAnalyticsCollectionEnabled(analytics, true)
      setUserId(analytics, user.uuid)
      setUserProperties(analytics, {
        email: user.email,
        name: user.name,
        system_user: user.is_system_user.toString(),
      })
    } catch (e: any) {
      console.error(e)
      // eslint-disable-next-line preserve-caught-error
      throw new Error(e.message)
    }
  }
}
